import React, { useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import EventForm from './EventForm'
import API from '../../../../services/api'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import Container from '../../../atoms/page/Page'
import Banner from '../../../atoms/banner/Banner'
import { useEvent } from '../../../../hooks/useEvent'
import NewEventForm from '../event'

function CloneEvent() {
  const { eventId } = useParams<{ eventId: string }>()

  const { inProgress, error, data } = useEvent(eventId)

  const onSave = useCallback((data: API.EventRequest) => {
    return API.duplicateEvent(eventId, data)
  }, [eventId])

  const history = useHistory()

  const onCancel = useCallback(() => {
    history.goBack()
  }, [history])

  if (data && (process.env.REACT_APP_USE_NEW_EVENT_UI === 'true')) {
    return <NewEventForm event={data} mode="clone" />
  }

  return (
    <Container>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active={!!error} message={error?.message} />}
      {
        data &&
          <EventForm event={{
            ...data,
            id: ''
          }} onSave={onSave} onCancel={onCancel} />
      }
    </Container>
  )
}

export default CloneEvent
